import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import {WandSparkles} from 'lucide-react';

const radios = [
    {name: 'Pending', value: 'Pending', variant: 'outline-dark'},
    {name: 'Important', value: 'Updated', variant: 'outline-danger', countKey: 'Updated'},
    {name: 'Task', value: '__TASK__', variant: 'outline-dark', isTask: true, countKey: 'Task'},
    {name: 'Scheduled', value: 'Scheduled', variant: 'outline-primary'},
    {name: 'InProgress', value: 'InProgress', variant: 'outline-warning'},
    {name: 'ReadyForBilling', value: 'ReadyForBilling', variant: 'outline-success'},
    {name: 'Cancelled', value: 'Cancelled', variant: 'outline-secondary'},
    {name: 'X', value: 'ALL', variant: 'outline-dark'},
];

function getButtonLabel(radio, statusCounts) {
    const countKey = radio.countKey || radio.name;
    const count = statusCounts[countKey];
    return count ? `${radio.name} (${count}) ` : `${radio.name}    `;
}

export default function JobStatusToggleGroup({
    radioValue,
    setRadioValue,
    statusCounts,
    isTaskSelected,
    onTaskClick,
    onAutoAssign,
    autoAssignDisabled = false,
}) {
    return (
        <ButtonGroup>
            {radios.map((radio, idx) => (
                <ToggleButton
                    key={idx}
                    id={`jobstatusradio-${idx}`}
                    type="radio"
                    variant={radio.variant}
                    name="radio"
                    value={radio.value}
                    checked={radio.isTask ? (isTaskSelected ?? false) : radioValue === radio.value}
                    onChange={() => {
                        if (radio.isTask && onTaskClick) {
                            onTaskClick();
                            return;
                        }
                        setRadioValue(radio.value);
                    }}
                >
                    {getButtonLabel(radio, statusCounts)}
                </ToggleButton>
            ))}
            {onAutoAssign ? (
                <button
                    type="button"
                    className="btn btn-outline-primary"
                    aria-label="Auto Assign"
                    title="Auto Assign"
                    disabled={autoAssignDisabled}
                    onClick={onAutoAssign}
                >
                    <WandSparkles size={16} aria-hidden="true" />
                </button>
            ) : null}
        </ButtonGroup>
    );
}
